function heroFade() {
    (function($) {
        const $body = $("body");

        const mgHero = document.querySelector(".mg-hero");
        const heroGraphic = document.querySelector(".mg-hero__graphic");
        const siteHeader = document.querySelector(".site-header");
        const adminBar = document.querySelector("#wpadminbar");
        const heroOverlap = document.querySelector("#hero-overlap");

        let initHeroBottomDistance;
        let controlHeight;
        let diffHeroBottomControlHeight;
        let pageOffset = 0;
        let heroOverlapAmount = 0;

        function updateFadeVariables() {
            if (!mgHero) return;

            // extra offset to account for #wpadminbar
            if (adminBar) {
                pageOffset += adminBar.getBoundingClientRect().height;
            }

            if (window.getComputedStyle && window.matchMedia) {
                if (
                    heroOverlap &&
                    window.matchMedia("(min-width: 576px)").matches
                ) {
                    heroOverlapAmount =
                        heroOverlap.getBoundingClientRect().height -
                        parseInt(getComputedStyle(heroOverlap).marginBottom) *
                            -1;
                } else {
                    heroOverlapAmount = 0;
                }
            }

            initHeroBottomDistance = mgHero.getBoundingClientRect().bottom;

            controlHeight =
                pageOffset +
                mgHero.getBoundingClientRect().height -
                heroOverlapAmount;

            if ($body.hasClass("home")) {
                controlHeight -= siteHeader.getBoundingClientRect().height;
            }

            // how much of the hero div has scrolled out from the viewport
            diffHeroBottomControlHeight =
                initHeroBottomDistance + $(window).scrollTop() - controlHeight;
        }

        function fade() {
            if (!mgHero && !heroGraphic) return;

            const heroBottomDistance = mgHero.getBoundingClientRect().bottom;
            const heroRemaining =
                (heroBottomDistance - diffHeroBottomControlHeight) /
                controlHeight;

            if (heroRemaining <= 0) {
                if (!$body.hasClass("mg-fix-header")) {
                    $(heroGraphic).css({ opacity: 0 });
                    $body.addClass("mg-fix-header");
                }
            } else {
                $(heroGraphic).css({ opacity: heroRemaining });

                if ($body.hasClass("mg-fix-header")) {
                    $body.removeClass("mg-fix-header");
                }
            }
        }

        $(function() {
            updateFadeVariables();
            fade();

            $(window).on("resize", function() {
                updateFadeVariables();
                fade();
            });

            $(window).scroll(function() {
                fade();
            });
        });
    })(jQuery);
}

export default heroFade;



// WEBPACK FOOTER //
// ./src/js/partials/hero-fade.js